import ApiService from './ApiService'

const ClientService = {
    async get(client) {
        const { data } = await ApiService.get('client.show', client)
        const clientData = { ...data.address, ...data }
        delete clientData.address
        delete clientData.address_id
        return clientData
    },

    index() {
        return ApiService.get('client.index', { page: -1 })
    },

    contracts(client) {
        return ApiService.get('client.contracts', client)
    },

    create(data) {
        return ApiService.post('client.store', data)
    },

    update(client, data) {
        return ApiService.patch('client.update', data, client)
    },

    delete(client) {
        return ApiService.delete('client.destroy', client)
    },

    dnbSearch(search) {
        return ApiService.get('client.dnb_search', { search })
    },

    lookupByDuns(duns) {
        return ApiService.get('client.lookup_by_duns', { duns })
    },

    fetchDnB({ client, force = false }) {
        return ApiService.get('client.dnb_report', { client, force: force ? 1 : 0 })
    },

    fetchCreditRiskByReport({ client, dnb_report }) {
        return ApiService.get('client.dnb_credit_risk', { client, dnb_report })
    },

    fetchStandardDataByReport({ client, dnb_report }) {
        return ApiService.get('client.dnb_standard_data', { client, dnb_report })
    },

    fetchBeneficialOwnership({ client, dnb_report }) {
        return ApiService.get('client.beneficial_ownership', { client, dnb_report })
    },
}

export default ClientService
